/** @jsx jsx */
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import BrandActions from '../Brand/BrandActions';

export default function ExhibitorActions({ exhibitor, ...rest }) {
  return <BrandActions brand={exhibitor} />;
}

export const fragment = graphql`
  fragment ExhibitorActions on Exhibitor {
    ...BrandActions
  }
`;
